import { useNavigation } from "@react-navigation/native";
import { useMutation } from "@tanstack/react-query";
import { Input, Text } from "@ui-kitten/components";
import Button from "components/Button";
import LoginContainer from "components/LoginContainer";
import { AUTH_SCREEN_BUTTON_BACKGROUND } from "constants/";
import i18n from "plugins/localization";
import { initiatePasswordResetFetcher } from "queries/user.queries";
import React, { useState } from "react";
import { View, Pressable } from "react-native";
import { emailIcon, loginInputProps } from "screens/Login/Login";
import toast from "utils/toast";

export default function ForgotPassword() {
  const navigation = useNavigation();
  const [username, setUsername] = useState("");

  const { mutateAsync: initPasswordReset, isLoading: initiatingPasswordReset } =
    useMutation(initiatePasswordResetFetcher);

  const sendPasswordResetCode = async () => {
    await initPasswordReset(username);
    toast.info(
      i18n.t("screens.ForgotPassword.emailSentMessage", { email: username })
    );
  };

  return (
    <LoginContainer title={i18n.t("screens.ForgotPassword.title")}>
      <View>
        <Input
          {...loginInputProps}
          placeholder={i18n.t("labels.email")}
          accessoryLeft={emailIcon}
          onChangeText={setUsername}
        ></Input>

        <Button
          style={{
            marginVertical: 15,
            backgroundColor: AUTH_SCREEN_BUTTON_BACKGROUND,
            borderColor: "transparent",
          }}
          onPress={sendPasswordResetCode}
          disabled={username === ""}
          loading={initiatingPasswordReset}
        >
          {i18n.t("screens.ForgotPassword.resetButton")}
        </Button>
      </View>
      <Pressable
        onPress={() => navigation.navigate("LoginFlow", { screen: "Login" })}
      >
        <Text style={{ color: "white", textAlign: "center" }}>
          {i18n.t("common.loginButton")}
        </Text>
      </Pressable>
    </LoginContainer>
  );
}
